/**
 * @class Popover Button
 */
import { Button, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import Loader from '../loader';
class PopoverButton extends Component {
  constructor(props) {
    super(props);
    this.buttonID = uuid();
    this.state = {
      isModalOpen: false
    };
  }
  render() {
    const _this$props = this.props,
      btnClassName = _this$props.className,
      list = _this$props.list,
      title = _this$props.title,
      isOpen = _this$props.isOpen,
      selected = _this$props.selected,
      width = _this$props.width,
      onToggle = _this$props.onToggle,
      enabled = _this$props.enabled,
      header = _this$props.header,
      onSelect = _this$props.onSelect,
      testingIdentifier = _this$props.testingIdentifier,
      loaded = _this$props.loaded;
    const isModalOpen = this.state.isModalOpen;
    const buttonID = "popover-button-target-".concat(this.buttonID);
    let popoverState = isOpen;
    // Check to see if the component is controlled externally
    if (typeof popoverState !== 'boolean') {
      popoverState = isModalOpen;
    }
    const onModalToggle = event => {
      if (typeof isOpen !== 'boolean') {
        this.setState({
          isModalOpen: !isModalOpen
        });
      }
      if (onToggle && !event.target.className.includes(this.buttonID)) {
        onToggle(event);
      }
    };
    const classes = "pull-right t-pb-btn-".concat(kebabCase(testingIdentifier), " ").concat(btnClassName);
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      disabled: !enabled,
      id: buttonID,
      className: classes
    }, title), /*#__PURE__*/React.createElement(Popover, {
      id: "popover-popover-source",
      trigger: "click legacy",
      target: buttonID,
      className: "dropover-body",
      placement: "bottom",
      delay: 0,
      isOpen: popoverState,
      toggle: onModalToggle
    }, header ? /*#__PURE__*/React.createElement(PopoverHeader, {
      style: {
        textAlign: 'center'
      }
    }, header) : null, /*#__PURE__*/React.createElement(PopoverBody, {
      className: "t-pb-popover"
    }, loaded ? /*#__PURE__*/React.createElement("ul", {
      style: {
        maxHeight: 200,
        overflow: 'auto',
        paddingTop: '5px',
        fontSize: '14px'
      }
    }, list.map((listItem, index) => {
      const item = listItem;

      // handle group labels
      if (Object.prototype.hasOwnProperty.call(item, 'groupLabel')) {
        return /*#__PURE__*/React.createElement("li", {
          style: {
            height: '35px',
            backgroundColor: 'grey',
            color: '#FFF'
          },
          key: item.groupLabel
        }, item.groupLabel);
      }
      const isSelected = selected === item.id;
      const onRowSelect = () => {
        if (!isSelected) {
          onSelect(item);
        }
      };
      const className = "t-pb-opt-index-".concat(index, " t-pb-opt-").concat(kebabCase(item.name), " ").concat(this.buttonID);
      return /*#__PURE__*/React.createElement("li", {
        style: {
          height: '35px',
          width
        },
        key: item.id,
        className: isSelected ? 'active' : ''
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          whiteSpace: 'nowrap'
        },
        className: className,
        onClick: onRowSelect,
        onKeyPress: onRowSelect,
        role: "button",
        tabIndex: "0"
      }, item.name));
    })) : /*#__PURE__*/React.createElement(Loader, {
      loaded: loaded,
      style: {
        fontSize: '4px',
        margin: '4em auto'
      }
    }))));
  }
}
PopoverButton.defaultProps = {
  className: '',
  onToggle: null,
  enabled: true,
  selected: null,
  isOpen: null,
  width: 275,
  header: null,
  loaded: true
};
PopoverButton.propTypes = {
  className: PropTypes.string,
  header: PropTypes.node,
  selected: PropTypes.string,
  width: PropTypes.number,
  enabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  list: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    groupLabel: PropTypes.string,
    name: PropTypes.string
  })).isRequired,
  title: PropTypes.string.isRequired,
  testingIdentifier: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  loaded: PropTypes.bool
};
export default PopoverButton;